import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";

import Input from "ui/base/Input";
import List from "ui/base/List";

import type { UserAccount } from "../store";
import { useSearchAccounts } from "../fabric";


type Props = {
	value: UserAccount;
	setValue: (value: UserAccount) => void;
};

export default function Search({ value, setValue }: Props) {
	const accounts = useSearchAccounts(value.name || "");

	const style = {
		option: {
			flexDirection: "column",
			"&.MuiAutocomplete-option": {
				alignItems: "flex-start"
			}
		}
	} satisfies SxProps;


	return (
		<Autocomplete<UserAccount, false, false, false>
			value={value.id ? value : null}
			inputValue={value.name || ""}
			onInputChange={(_, v, reason) => {
				if (reason === "input" || reason === "clear") setValue({ name: v });
			}}
			onChange={(_, v) => setValue(v ?? { name: "" })}
			options={accounts.data || []}
			isOptionEqualToValue={(o, v) => o.id === v.id}
			renderInput={({ InputProps, InputLabelProps, ...params }) =>
				<Input {...params} {...InputProps} label="Find User" />
			}
			getOptionLabel={(o) => `${o.nickname || o.name || ""}`}
			renderOption={({ key, ...props }, o) => (
				<List.Item key={key} {...props} sx={style.option}>
					<Typography variant="body1">{o.nickname || o.name || "N/A"}</Typography>
					<Typography variant="body4" color="textSecondary">{o.email || o.phone}</Typography>
				</List.Item>
			)}
			getOptionKey={(o) => (o.id || o.name || o.email)!}
			filterOptions={(x) => x}
			fullWidth
		/>
	);
}